import { Link } from "react-router-dom";
import { Wrench } from "lucide-react";

export const Logo = ({ light = false }) => (
  <Link to="/" data-testid="site-logo" className="flex items-center gap-2">
    <span className="grid size-9 place-items-center rounded-xl bg-orange-600 text-white shadow-sm">
      <Wrench className="size-5" />
    </span>
    <span className={`font-heading text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-slate-900"}`}>
      Handy<span className="text-orange-500">Zoom</span>
    </span>
  </Link>
);
